export default __webpack_public_path__ + "static/workflow-4f0712d709da38f20ebdea41950743cf.jpg";